import { Paper } from '@mui/material'
import { useSelector } from 'react-redux'
import SearchBar from './SearchBar'
import MemberList from './MemberList'
import MemberListSkeleton from './MemberListSkeleton'

function MemberSearch() {
  const { searchLoading } = useSelector(state => state?.member)
  
  return (
    <Paper sx={{ width: '100%', mb: 2, minHeight: '500px' }}>
      <SearchBar />
      {searchLoading ? <MemberListSkeleton /> : <MemberList />}
    </Paper>
  )
}

export default MemberSearch
